module.exports = __webpack_public_path__ + "c07d9def2a5bb452430c545a2adc0fa1.jpeg";